import { render, staticRenderFns } from "./kscore.vue?vue&type=template&id=ddd78480"
import script from "./kscore.vue?vue&type=script&lang=js"
export * from "./kscore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports